export default __webpack_public_path__ + "static/media/single-chat-ss.6461f75e.svg";